/*@flow*/
import { useState, useEffect } from 'react';
import hash from 'lib/hash';
import decks from './decks';
import type { OptionsT } from './types';

type DeckContainerPropsT = { options: mixed, owner: ?Leaflet$Map };

export default (props: DeckContainerPropsT): any | null => {
  const o = ((props.options: any): OptionsT);
  const [options, setOptions] = useState(o);
  const [owner, setOwner] = useState(props.owner);

  useEffect(() => {
    setOwner(() => props.owner);
  }, [props.owner]);

  useEffect(() => {
    setOptions(() => o);
  }, [hash(o)]);
  let { type } = options;
  const d = decks(type);
  if (!d) return null;
  const el = d({ owner, options });
  if (!owner) return null;
  return el || null;
};
